import React, { useEffect } from "react";
import PropTypes from "prop-types";
import TextArea from "../common/formfields/TextArea"

const EventCancellationForm = ({
    event,
    onSave,
    onCancel,
    onChange,
    saving = false,
    errors = {}
}) => {
    return (
        <form onSubmit={onSave} className="">
            {errors.onSave && (
                <div className="alert alert-danger" role="alert">
                    {errors.onSave}
                </div>
            )}

            <TextArea
                name="cancellationReason"
                label="Cancellation Reason"
                maxLength="500"
                cols="75"
                rows="6"
                value={event.cancellationReason}
                onChange={onChange}
                error={errors.cancellationReason}
            />

            <button type="submit" disabled={saving} className="btn btn-primary float-right">
                {saving ? "Saving..." : "Save"}
            </button>
            <button className="btn btn-secondary float-right mr-1" onClick={onCancel}>
                Cancel
            </button>


        </form>

    );
}

EventCancellationForm.propTypes = {
    event: PropTypes.object.isRequired,
    errors: PropTypes.object,
    onSave: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    saving: PropTypes.bool
}

export default EventCancellationForm;


// WEBPACK FOOTER //
// ./src/components/events/EventCancellationForm.js